module.exports = __webpack_public_path__ + "static/assets/6c08c47309997cd9fa173e18b17c3a09.svg";